import ApplicationController from "./application_controller"
import { current } from "../helpers/current_helpers"

const TIMEOUT = 500

export default class extends ApplicationController {
  static targets = ["input"]

  async connect() {
    super.connect()

    await this.initialize()
  }

  async initialize () {
    const FingerprintJS = await import(this.config.scriptUrl)

    this.agent = await FingerprintJS.load({
      endpoint: [this.config.endpoint, FingerprintJS.defaultEndpoint]
    })

    if (this.hasInputTarget) {
      this.attachEventListener(this.element, "submit", this.fingerprintAndSubmit)
    }
  }

  fingerprintAndSubmit = async (e) => {
    if (this.isProcessing) { return }

    e.preventDefault()
    this.isProcessing = true

    this.element.setAttribute("aria-busy", true)

    try {
      await this.fingerprint()
    } catch (error) {
      window.airbrake.notify(error)
      console.error(error)
    } finally {
      this.element.setAttribute("aria-busy", false)
      this.element.requestSubmit()

      this.isProcessing = false
    }
  }

  async fingerprint () {
    const result = await this.agent.get({ timeout: TIMEOUT })

    if (this.hasInputTarget) {
      this.inputTarget.value = result.requestId
    }

    this.dispatch("complete", { detail: result })
  }

  get config () {
    return {
      scriptUrl: current.fingerprint.scriptUrl,
      endpoint: current.fingerprint.endpoint,
      apiKey: current.fingerprint.apiKey
    }
  }
}
